<template>
  <ul class="list-group">
    <li
      @click="$emit('on-detail', t)"
      role="button"
      class="list-group-item list-group-item-action d-flex align-items-center bd-0"
      v-for="(t, i) in tasks"
      :key="i"
    >
      <div class="avatar">
        <span :class="`avatar-initial rounded bg-transparent bd bd-gray-900`">
          <i class="tx-24 far tx-color-02 fa-file-code"></i>
        </span>
      </div>
      <div class="pd-l-10">
        <h6 class="tx-13 tx-color-02 tx-semibold mg-b-0">{{ t.task }}</h6>
        <span class="d-block tx-11 tx-color-03">HTML</span>
      </div>
    </li>
  </ul>
  <!-- <div class="row row-xs">
    <div class="col-xs-12 col-sm-6 col-md-6 col-lg-4 col-xl-4 col-xxl-2" v-for="(t,i) in tasks" :key="i">
        <div class="card overflow-hidden">
          <div class="ht-100 bg-info d-flex align-items-center">
            <h1 class="text-center text-white wd-100p">HTML</h1>
          </div>
          <div class="card-body tx-13 pd-b-10 pd-x-15">
            <div class="d-flex align-items-center" @click="$emit('on-detail', t)" role="button">
              <div class="wd-18p">
              <feather type="code" :size="32" :stroke-width="1" class="text-primary mg-r-10"></feather>
              </div>
              <h6><a class="link-02">{{t.task}}</a></h6>
            </div>
          </div>
        </div>

    </div>
    
  </div> -->
</template>

<script>
export default {
  props: {
    box: {
      type: Object,
      default: () => {}
    },
    tasks: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    showDetail(t) {
      if (this.$route.params.bot == 435) {
        this.$emit("on-detail", t);
      } else {
        this.$router.push({
          name: "lmsLessonView",
          params: {
            id: this.$route.params.id,
            cid: this.$route.params.cid,
            bid: this.box.id,
            iid: t.id,
            bot: this.box.ot
          }
        });
      }
    }
  }
};
</script>

<style></style>
